module.exports = "<div class=ws-input-pills__wrapper ng-click=$ctrl.focusInput()> <div class=ws-input-pills__pill ng-repeat=\"pill in $ctrl.pills\"> {{ pill }} <span class=ws-input-pills__pill-dismiss ng-click=$ctrl.removePill(pill)> {{ $ctrl.dismissText }} </span> </div> <input class=ws-input-pills__input ng-change=\"$ctrl.onModelChange({ pills: $ctrl.pills, pillInput: $ctrl.pillInput });\" ng-keydown=$ctrl.keydownHandler($event) ng-keypress=$ctrl.keypressHandler($event) ng-model=$ctrl.pillInput placeholder=\"{{ $ctrl.placeholderText }}\" type=text /> </div> ";


//////////////////
// WEBPACK FOOTER
// ./src/form/ws-input-pills/ws-input-pills.tmpl.html
// module id = 46
// module chunks = 0